<template>
  <AppTableControl
    :search-place-holder="$t('COMMON.Actions.Search')"
    @query-debounced="searchName"
    no-export
    no-filter
  ></AppTableControl>
</template>

<script>
import AppTableControl from "@/modules/core/components/shared/table/AppTableControl";
export default {
  name: "LeaveEmployeeTableControl",
  components: { AppTableControl },
  beforeDestroy() {
    this.$store.dispatch("changeEmployeeListForLeaveBaseFilter", {
      base: null,
    });
  },
  methods: {
    /**
     * Search name.
     *
     * @param nameQuery
     */
    searchName(nameQuery) {
      console.log(nameQuery);

      this.$store.dispatch("changeEmployeeListForLeaveBaseFilter", {
        base: nameQuery,
      });

      this.$store.dispatch("fetchEmployeeListForLeave");
    },
  },
};
</script>

<style scoped></style>
